module.exports = __webpack_public_path__ + "static/media/reports-ss.7ecaab0e.png";